import { useEffect } from 'react';

const addListeners = (listeners, map, wrapper) =>
  Object.keys(listeners).reduce((carry, name) => {
    carry[name] = map.addListener(name, () => wrapper(listeners[name]));
    return carry;
  }, {});

const removeListeners = (listeners) => {
  Object.keys(listeners).forEach((name) =>
    window.google.maps.event.removeListener(listeners[name]));
};

function useListeners(listeners, map, wrapper) {
  useEffect(() => {
    let boundListeners = {};

    if (map) {
      boundListeners = addListeners(listeners, map, wrapper);
    }

    return () => removeListeners(boundListeners);
  }, [listeners, map, wrapper]);
}

export default useListeners;
